import { cn, truncateDecimals } from '@lair-finance/util'
import { AssetItem } from '@/domains/header/ui/WalletModal/WalletAsset/AssetItem.tsx'
import { TokenAddresses, TokenImages, TokenTickers } from '@/shared/config/token.ts'
import { TokenSymbol } from '@/shared/ui/Symbol'
import { useTokenBalance } from '@/shared/lib/wagmi/hooks/useTokenBalance.ts'
import { useAccount } from '@lair-finance/wagmi'
import { commafy } from '@/shared/lib/utils/format.ts'
import { ACTIVE_KAIA_CHAIN } from '@/shared/config/chain.ts'

export function WalletAsset({ className }: { className?: string }) {
  const chainId = useAccount().chainId

  const { balance: kaiaBalance } = useTokenBalance({ chainId: ACTIVE_KAIA_CHAIN.id, watch: true })
  const { balance: lairBalance } = useTokenBalance({ chainId, tokenAddress: TokenAddresses[chainId!].LAIR, watch: true, enabled: Boolean(chainId) })
  const { balance: stKaiaBalance } = useTokenBalance({
    chainId: ACTIVE_KAIA_CHAIN.id,
    tokenAddress: TokenAddresses[ACTIVE_KAIA_CHAIN.id].stKAIA,
    watch: true,
  })
  const { balance: rstKaiaBalance } = useTokenBalance({
    chainId: ACTIVE_KAIA_CHAIN.id,
    tokenAddress: TokenAddresses[ACTIVE_KAIA_CHAIN.id].rstKAIA,
    watch: true,
  })

  const formatAmount = (balance: string | undefined) => (balance ? commafy(truncateDecimals(balance, 4)) : '0')

  return (
    <div className={cn('flex flex-col gap-y-1', className)}>
      <AssetItem icon={<TokenSymbol src={TokenImages.LAIR} size={24} />} name={TokenTickers.LAIR} amount={formatAmount(lairBalance)} />
      <AssetItem icon={<TokenSymbol src={TokenImages.KAIA} size={24} />} name={TokenTickers.KAIA} amount={formatAmount(kaiaBalance)} />
      <AssetItem icon={<TokenSymbol src={TokenImages.stKAIA} size={24} />} name={TokenTickers.stKAIA} amount={formatAmount(stKaiaBalance)} />
      <AssetItem icon={<TokenSymbol src={TokenImages.rstKAIA} size={24} />} name={TokenTickers.rstKAIA} amount={formatAmount(rstKaiaBalance)} />
    </div>
  )
}
